import { createFileRoute } from '@tanstack/react-router'
import { CertificationRequestDetailsPage } from '@/features/certification/pages/certification-request-details-page'

export const Route = createFileRoute('/_authenticated/_sidebar/observer/requests/$requestId')({
  component: CertificationRequestDetails,
})

function CertificationRequestDetails() {
  const { requestId } = Route.useParams()
  return <CertificationRequestDetailsPage requestId={requestId} />
}

